export enum KlSearchDeadLetterFilters {
    CorrelationId = 'correlationId',
    MessageType = 'MessageType',
}